<template>
  <div class="wrapper">
    <h1>{{object.question}}</h1>
    <div class="resp-wrap">
      <div class="choices"
        v-for="(choice, index) in object.responses"
        v-bind:key="index"
        @click="checkAnswer(choice.isCorrect)"
      >
        <div></div>
        <p>{{choice.text}}</p>
      </div>
    </div>
    <modal-ok
      :isShown="(hasAnswer && isCorrect)"
      @onClicked="nextStep"
    />
    <modal-ok
      :message="'Oops... Your answer is incorrect'"
      :buttonLabel="'Try Again'"
      :isShown="(hasAnswer && !isCorrect)"
      @onClicked="nextStep"
    />
  </div>
</template>

<script>
import ModalOk from '../../components/modal-ok/modalOk'

export default {
  name: 'Quiz',
  components: {
    ModalOk
  },
  data () {
    return {
      questionObj: {},
      hasAnswer: false,
      isCorrect: false
    }
  },
  props: [
    'dataId',
    'object'
  ],
  methods: {
    checkAnswer (isCorrect) {
      this.hasAnswer = true
      this.isCorrect = isCorrect
    },
    nextStep () {
      if (this.isCorrect) {
        alert('Move to next step')
      } else {
        this.hasAnswer = false
        this.isCorrect = false
      }
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/quiz/Quiz.vue